import { Text, View } from "@flip.id/ui-kit";
import * as React from "react";
import type { IBadgePropsNew } from "./types";

const BadgeVA = (props: IBadgePropsNew) => {
  return (
    <View
      px={"8px"}
      py={"2px"}
      background={`${props.colorScheme}.Plus1`}
      borderWidth={"1px"}
      borderColor={"neutral.White"}
      roundedBottomLeft={"8px"}
      roundedBottomRight={"8px"}
      {...props._box}
    >
      {props.label !== "" && (
        <Text color={"neutral.White"} fontSize="sm">
          {props.label}
        </Text>
      )}
    </View>
  );
};

export default BadgeVA;
